import React from "react";
import Selector from "./Selector";
import { groupedSelectorStyles } from "./styles";
import GroupedSelectorGroupTextHeader from "./GroupedSelectorGroupTextHeader";
import GroupedSelectorOption from "./GroupedSelectorOption";
const GroupedSelector = (props) => (React.createElement(Selector, { ...props, styles: groupedSelectorStyles, formatGroupLabel: props.formatGroupLabel ?? GroupedSelectorGroupTextHeader, SelectorOption: props.SelectorOption ?? GroupedSelectorOption }));
export default GroupedSelector;
